import PRESETS from "./presets/"

function initHighchartsFunction(H, functionName, defaultData) {
  //TODO better handling for H object in presetData
  const originalHighchartsFunction = H[functionName]
  H[functionName] = function () {
    const options = arguments[1]
    const {preset} = options //TODO allow prest array

    const presetData = PRESETS[preset] || {}
    const presetEvents = (presetData ? presetData.presetEvents : null) || {}

    presetEvents.beforeMerge?.(H, presetData, options)
    arguments[1] = H.merge(H.merge(defaultData, presetData), options)
    presetEvents.afterMerge?.(H, arguments[1])

    if (presetEvents.chartEvents) {
      const orgCallback = arguments[2]

      arguments[2] = function (chart) {
        presetEvents.chartEvents?.init?.apply(this, chart)
        Object.keys(presetEvents.chartEvents).forEach(event => {
          H.addEvent(chart, event, presetEvents.chartEvents[event])
        })
      }
      if(orgCallback){
        orgCallback.apply(this, arguments)
      }
    }

    //set initRangeselction to selection
    const rangeSelector = arguments[1].rangeSelector
    if(rangeSelector && rangeSelector.initSelection && !rangeSelector.selected){
      rangeSelector.selected=rangeSelector.initSelection
    }

    const result = originalHighchartsFunction.apply(this, arguments)
    return result
  }
}

export default function (H) {
  initHighchartsFunction(H, 'chart', { })
  initHighchartsFunction(H, 'stockChart', { //disable panning by default...dont work in highcarts init
    chart:{
      panning: {
        enabled: false
      }
    }
  })
}

